import { InvoiceProcessingOnHold } from "../InvoiceProcessingOnHold";
import { InvoiceProcessingProcessing } from "../InvoiceProcessingProcessing";
import { InvoiceReadyToProcessList } from "../InvoiceReadyToProcessList";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessing extends Layout {
    buttonCreditRebill: Button;
    horizontalspacer2: HorizontalSpacer;
    labelHold: Tab;
    labelInvoiceProcessing: Label;
    labelProcessing: Tab;
    labelReadyToProcess: Tab;
    layoutInvoiceProcessingHold: InvoiceProcessingOnHold;
    layoutInvoiceProcessingProcessing: InvoiceProcessingProcessing;
    layoutInvoiceReadyToProcess: InvoiceReadyToProcessList;
    panelHeader: Panel;
    sourceInvoiceProcessingCache: DataSource;
    tabsetMain: Tabset;
}
